import { Button, Center, VStack } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useProductActions } from 'src/hooks/product/useProductActions'
import { useAppDispatch } from 'src/hooks/store'
import { openCartDrawer } from 'src/redux/cart/slice'
import { Product } from 'src/types/types'
import DrawerWrapper from '../DrawerWrapper/DrawerWrapper'
import DescriptionContent from './DescriptionContent'

export interface ProductDetailsDrawerProps {
  isDrawerVisible: boolean
  hideDrawer: () => void
  product?: Product
}

const ProductDetailsDrawer: React.FC<ProductDetailsDrawerProps> = ({
  isDrawerVisible,
  hideDrawer,
  product,
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { addToCart, removeFromCart, isLoading, isAddedToCart } = useProductActions(product)

  const handleSuccess = () => {
    hideDrawer()
    setTimeout(() => dispatch(openCartDrawer()), 200)
  }

  const handleAddToCart = () => {
    addToCart(handleSuccess)
  }

  return (
    <DrawerWrapper onClose={hideDrawer} isVisible={isDrawerVisible}>
      <Center height='100%'>
        <VStack spacing={4} align='center' padding={5}>
          <DescriptionContent product={product!} />
          {isAddedToCart ? (
            <Button colorScheme='red' onClick={() => removeFromCart()} isLoading={isLoading}>
              {t('common.removeFromCart')}
            </Button>
          ) : (
            <Button colorScheme='teal' onClick={handleAddToCart} isLoading={isLoading}>
              {t('common.addToCart')}
            </Button>
          )}
        </VStack>
      </Center>
    </DrawerWrapper>
  )
}

export default ProductDetailsDrawer
